<template>
	<div :class="{blue}" class="initial-info-container">
		<div v-if="title || finalIncrement" class="row centered flex-start row-values-head">
			<p class="info-caption" :class="{fullrow: !lastPeriodValue}">{{ title }}</p>
			<p v-show="!!lastPeriodValue" :class="{negative: increment && increment < 0}" :title="parsedIncrement" class="info-increment">{{ finalIncrement }}</p>
		</div>
		<div class="row align-end space-between row-values">
			<p class="info-value">{{ finalValue }}</p>
			<p class="info-last-period-value" v-show="lastPeriodValue !== null">{{ finalLastPeriodValue }}</p>
		</div>
		<slot></slot>
	</div>
</template>

<script>
import {useCurrencyStore} from "@/shared/stores";

export default {
	setup() {
		const currencyStore = useCurrencyStore();
		return {currencyStore};
	},
	name: "UserInitialCardInfo",
	props: {
		title: {type: String, default: ''},
		value: {type: Number, default: 0},
		lastPeriodValue: {type: Number, default: 0},
		withCents: {type: Boolean, default: false},
		noCurrency: {type: Boolean, default: false},
		symbol: {type: String, default: ''},
		blue: {type: Boolean, default: false},
	},
	computed: {
		increment() {
			if(!this.lastPeriodValue) { return null; }
			let difference = this.value - this.lastPeriodValue;
			return difference/this.lastPeriodValue*100;
		},
		parsedIncrement() {
			if(this.increment === null) { return null; }
			let finalValueRounded = Math.round(this.increment * 10) / 10;
			finalValueRounded = finalValueRounded % 1 ? finalValueRounded.toFixed(1) : finalValueRounded.toString();
			return finalValueRounded + '%';
		},
		finalIncrement() {
			if(this.increment === null) { return null; }
			if(this.parsedIncrement.length <= 6) {
				return this.parsedIncrement;
			}
			let returning = this.parsedIncrement.substring(0, 3);
			returning += returning.endsWith('.') ? '..' : '...';
			return returning + '%';
		},
		finalValue() {
			if(this.value !== null) {
				if(this.noCurrency) {
					return this.value+this.symbol;
				} else {
					return this.currencyStore.readableCurrencyValue(this.value, false, true, !this.withCents || !this.value);
				}
			} else {
				return '-';
			}
		},
		finalLastPeriodValue() {
			if(this.lastPeriodValue !== null) {
				if(this.noCurrency) {
					return this.lastPeriodValue+this.symbol;
				} else {
					return this.currencyStore.readableCurrencyValue(this.lastPeriodValue, false, true, !this.withCents || !this.value);
				}
			} else {
				return '-';
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.initial-info-container {
	height: 100%;
	width: 100%;
	padding: 10px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	&.blue {
		box-shadow: $box_shadow_inset;
		background-color: var(--color-bg-primary-1);
		border-radius: 13px;
	}

	.row-values-head {
		flex-wrap: nowrap;
		gap: 8px;
	}

	.row-values {
		flex-wrap: wrap;
		gap: 8px;
	}

	p.info-value {
		font-size: 26px;
		line-height: 28px;
	}
	p.info-last-period-value {
		color: #9B9B9B;
		font-size: 16px;
		line-height: 20px;
		white-space: nowrap;
		margin-left: auto;
	}
	p.info-caption {
		color: #9B9B9B;
		font-size: 14px;
		line-height: 16px;
		user-select: none;
		padding-bottom: 2px;
		@include truncateString(1);
	}
	p.info-caption.fullrow {
		max-width: unset;
	}
	p.info-increment {
		font-size: 12px;
		line-height: 14px;
		user-select: none;
		@include truncateString(1);
		&:not(:empty) {
			border-radius: 8px;
			padding: 4px 5px;
			max-width: 55px;
			background: rgb(215,247,194);
			color: rgb(0,105,8);

			&.negative {
				background: rgb(252,237,185);
				color: rgb(168,44,0);
			}
		}
	}

	@mixin smallText {
		p.info-value {
			font-size: 22px;
			line-height: 24px;
		}
		p.info-last-period-value {
			font-size: 14px;
			line-height: 16px;
		}
		p.info-caption {
			font-size: 12px;
			line-height: 14px;
		}
		p.info-increment {
			font-size: 10px;
			line-height: 12px;
		}
	}

	@media (min-width: 960px) and (max-width: 1080px) {
		@include smallText;
	}
	@media (max-width: 768px) {
		@include smallText;
	}
}
</style>